//#region IMPORT
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
/** Services Import */
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
/** Components */
import { HEA_BASIC } from './index';
import { Loading } from '../../../../Components/MUIs';
import dayjs from 'dayjs';
import useCompanyCustDepRedux from '../../../../hooks/useCompanyCustDep';
import useActionLog from '../../../../hooks/useActionLog';
//#endregion

// 화면 MENU_ID
const SCREEN_MENU_ID = 'HealthCheckup';

function HEA_BASICF() {
  //#region 공통 변수
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(0); // 탭 상태 (0: 일반건강진단, 1: 특수건강진단)
  //#endregion

  //#region Redux 관련
  const dispatch = useDispatch();
  const { userInfo, custInfo, lanInfo } = useSelector(
    (state) => state.BaseInfo
  );
  const searchInfo = useSelector((state) => state.SearchInfo);

  //#endregion

  //#region 조회조건 변수
  const { handleCoChange, handleCustChange, validateSelection } =
    useCompanyCustDepRedux({ requireCompany: true, requireCust: true });
  //#endregion

  //#region 그리드 변수
  const gridRef1 = useRef(null); //기본정보 그리드 (일반건강진단)
  const gridRef1_2 = useRef(null); //기본정보 그리드 (특수건강진단)
  const gridRef2 = useRef(null);
  const gridRef3 = useRef(null); //엑셀업로드용 그리드

  /* 그리드 기능 변수 */
  // rowData1, setRowData1 등은 HEA_BASIC_01F.js로 이동됨
  const currentRowIndexRef1 = useRef(null);

  const rowClickData = useRef(null);

  // 탭별 클릭 핸들러 상태 변수
  const [searchClick1, setSearchClick1] = useState(false); // 일반건강진단 탭
  const [saveClick1, setSaveClick1] = useState(false);
  const [deleteClick1, setDeleteClick1] = useState(false);
  const [printClick1, setPrintClick1] = useState(false);
  const [printClick1Guideline, setPrintClick1Guideline] = useState(false);

  // printItem1: 일반건강진단 탭용
  const printItem1 = [
    {
      name: '일반건강진단',
      onClick: () => {
        setPrintClick1(true);
      },
    },
    {
      name: '건강진단 실시 지침서',
      onClick: () => {
        setPrintClick1Guideline(true);
      },
    },
  ];

  // printItem2: 특수건강진단 탭용
  const printItem2 = [
    {
      name: '특수건강진단',
      onClick: () => {
        setPrintClick2(true);
      },
    },
    {
      name: '건강진단 실시 지침서',
      onClick: () => {
        setPrintClick2Guideline(true);
      },
    },
  ];

  const [searchClick2, setSearchClick2] = useState(false); // 특수건강진단 탭
  const [saveClick2, setSaveClick2] = useState(false);
  const [deleteClick2, setDeleteClick2] = useState(false);
  const [printClick2, setPrintClick2] = useState(false);
  const [printClick2Guideline, setPrintClick2Guideline] = useState(false);
  //#endregion

  //#region 엑셀 변수
  const fileInputRef = useRef(null); //#파일 업로드 관련
  const [readyToExport, setReadyToExport] = useState(false); // 엑셀 Export
  const [excelData, setExcelData] = useState([
    // 엑셀 데이터
    {
      HC_ID: '사용자ID',
      HC_SUBSTANCE: '취급물질',
      HC_NOISE: '소음작업',
      HC_NIGHT: '야간작업',
      HC_GUBUN: '특수',
      HC_CYCLE: '3달',
      HC_DATE: '2025-11-11',
      HC_EFFE_DATE: '2025-11-11',
    },
  ]); //엑셀용 그리드 데이터
  //#endregion

  //#region 모달 변수
  const [modalToggle1, setModalToggle1] = useState(false);
  const [modalRowData1, setModalRowData1] = useState([]);
  const [selectedModalRowData1, setSelectedModalRowData1] = useState([]);
  const [changedModalRowData1, setChangedModalRowData1] = useState([]);
  //#endregion

  //#region useEffect
  /* 엑셀 다운로드 */
  useEffect(() => {
    if (readyToExport && gridRef3.current) {
      gridRef3.current.api.exportDataAsExcel({
        fileName: dayjs().format('YYYYMMDDHHmm') + '건강검진.xlsx',
      });
      setReadyToExport(false); // 여러 번 클릭 방지
    }
  }, [readyToExport]);

  const executed = useRef(false);

  useEffect(() => {
    if (!executed.current && searchInfo.custCd) {
      Init();
      executed.current = true; // 다시 실행 안 되게
    }
  }, [searchInfo.custCd]);

  const Init = async () => {
    setSearchClick1(true);
  };

  //#region 저장
  //엑셀 업로드 시 저장 함수
  const SaveLogic2 = async () => {
    setLoading(true);

    try {
      // changedRowData1는 HEA_BASIC_01F에서 관리됨
      // const changedRows = changedRowData1.filter((row) => !row.deleteYn);
      const changedRows = [];
      const hasChange = changedRows.length > 0;

      if (!hasChange) {
        dispatch(
          showSnackbar({
            message: '저장할 데이터가 없습니다.',
            type: 'warning',
          })
        );
        return;
      }

      if (hasChange) {
        const saveData = changedRows.map((_item) => ({
          procedureName: 'SP_HEA_BASIC_U1',
          _HC_CD: Commons.EncryptAES(_item.HC_CD) || '',
          _HC_ID: Commons.EncryptAES(_item.HC_ID) || '',
          _CUST_CD: Commons.EncryptAES(searchInfo.custCd) || '',
          _HC_SUBSTANCE: Commons.EncryptAES(_item.HC_SUBSTANCE) || '',
          _HC_NOISE: Commons.EncryptAES(_item.HC_NOISE) || '',
          _HC_NIGHT: Commons.EncryptAES(_item.HC_NIGHT) || '',
          _HC_GUBUN: Commons.EncryptAES(_item.HC_GUBUN) || '',
          _HC_CYCLE: Commons.EncryptAES(_item.HC_CYCLE) || '',
          _HC_DATE:
            Commons.EncryptAES(dayjs(_item.HC_DATE).format('YYYY-MM-DD')) || '',
          _HC_EFFE_DATE:
            Commons.EncryptAES(
              dayjs(_item.HC_EFFE_DATE).format('YYYY-MM-DD')
            ) || '',
          _USER_ID: userInfo.userid || '',
        }));

        try {
          const result = await Commons.Axios(
            'post1',
            Global.base.useUrl + Global.urls.Execute.execute,
            saveData
          );
          const data = result.data;

          if (data.length === 0) {
            dispatch(
              showSnackbar({
                message: '저장 후 반환된 값이 없습니다.',
                type: 'error',
              })
            );
            return;
          } else if (data?.[0]?.type === 'Error') {
            dispatch(
              showSnackbar({
                message: data[0].message || '에러가 발생했습니다.',
                type: 'error',
              })
            );
            return;
          } else {
          }
        } catch {
          dispatch(
            showSnackbar({
              message: '오류가 발생했습니다. 잠시 후 다시 시도해주세요.',
              type: 'error',
            })
          );
          return;
        }
      }

      if (hasChange) {
        dispatch(
          showSnackbar({
            message: '저장되었습니다.',
            type: 'success',
          })
        );
      }

      // SearchLogic1은 HEA_BASIC_01F에서 처리됨
    } catch (e) {
      console.error(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: e.code === 'CUSTOM_ERROR' ? e.type : 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  //#region 나머지 함수
  const PopupClickEvent1 = async (e) => {
    setModalToggle1(true);
    // rowClickData에 rowIndex와 data 저장
    rowClickData.current = {
      rowIndex: e.rowIndex,
      data: e.data,
    };
  };

  //엑셀다운로드 버튼 클릭 시
  const ExcelDownload = async () => {
    setReadyToExport(true);
  };

  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  const handleRowSelection1 = (rowData, rowIndex) => {
    currentRowIndexRef1.current = rowIndex;
    // setSelectedRowData1는 HEA_BASIC_01F에서 처리됨
  };

  // 회원정보 모달 이벤트 : 저장버튼, 더블클릭
  const HandleManageSelection = (
    selectedFromEvent = null,
    setChangedRowData1Callback = null,
    targetGridRef = null
  ) => {
    // 모달 닫기
    setModalToggle1(false);

    // 현재 탭에 따라 gridRef 선택 (특수건강진단 탭은 gridRef1_2 사용)
    const gridRef = targetGridRef || (value === 1 ? gridRef1_2 : gridRef1);
    const api = gridRef?.current?.api;
    if (!api) return;

    let rowIndex = rowClickData.current?.rowIndex;
    let rowNode = null;

    // ✅ 1. rowClickData.current가 없는 경우 (자동 모달 오픈 시)
    if (rowIndex === undefined) {
      const allNodes = [];
      api.forEachNode((node) => allNodes.push(node));

      // newYn === 'Y' 행들만 추출
      const newRows = allNodes.filter((n) => n.data?.newYn === 'Y');

      // ✅ 가장 마지막에 추가된 새 행 선택
      const newRow = newRows[newRows.length - 1];
      if (newRow) {
        rowNode = newRow;
      }
    } else {
      // ✅ 2. 클릭된 행이 있는 경우 (수동 설정 클릭 시)
      rowNode = api.getDisplayedRowAtIndex(rowIndex);
    }

    // ✅ 3. 혹시 아직 rowNode를 못 찾았으면 (Grid 반영 지연 시)
    if (!rowNode) {
      console.warn(
        'HandleManageSelection: 대상 행(rowNode)을 찾지 못했습니다. 100ms 후 재시도합니다.'
      );

      // 🔸 Grid 렌더링 지연 대응 (100ms 후 재탐색)
      setTimeout(() => {
        const allNodes = [];
        api.forEachNode((node) => allNodes.push(node));

        const newRows = allNodes.filter((n) => n.data?.newYn === 'Y');
        const newRow = newRows[newRows.length - 1];

        if (newRow) {
          const selected = selectedFromEvent || selectedModalRowData1?.[0];
          if (!selected) return;

          const updatedData = {
            ...newRow.data,
            HC_ID: selected.ID,
            NAME: selected.NAME,
            DEP_NM1: selected.DEP_NM1,
            DEP_NM2: selected.DEP_NM2,
            DEP_NM3: selected.DEP_NM3,
            DEP_NM4: selected.DEP_NM4,
            POSITION: selected.POSITION,
            editYn: 'Y',
          };
          newRow.setData(updatedData);

          // changedRowData1 업데이트
          if (setChangedRowData1Callback) {
            setChangedRowData1Callback((prev) => {
              const filtered = prev.filter((row) => row.no !== updatedData.no);
              return [...filtered, updatedData];
            });
          }

          api.setFocusedCell(newRow.rowIndex, 'NAME');
          api.startEditingCell({
            rowIndex: newRow.rowIndex,
            colKey: 'NAME',
          });
        }
      }, 100);

      return; // 재시도 예약 후 종료
    }

    // ✅ 4. 모달에서 선택한 데이터 가져오기
    const selected = selectedFromEvent || selectedModalRowData1?.[0];
    if (!selected) {
      console.warn('HandleManageSelection: 선택된 데이터가 없습니다.');
      return;
    }

    // ✅ 5. 그리드 데이터 업데이트
    const updatedData = {
      ...rowNode.data,
      HC_ID: selected.ID,
      NAME: selected.NAME,
      DEP_NM1: selected.DEP_NM1,
      DEP_NM2: selected.DEP_NM2,
      DEP_NM3: selected.DEP_NM3,
      DEP_NM4: selected.DEP_NM4,
      POSITION: selected.POSITION,
      editYn: 'Y',
    };
    rowNode.setData(updatedData);

    // ✅ 5-1. changedRowData1 업데이트
    if (setChangedRowData1Callback) {
      setChangedRowData1Callback((prev) => {
        const filtered = prev.filter((row) => row.no !== updatedData.no);
        return [...filtered, updatedData];
      });
    }

    // ✅ 6. 포커스 및 편집 모드 설정
    api.setFocusedCell(rowNode.rowIndex, 'NAME');
    api.startEditingCell({
      rowIndex: rowNode.rowIndex,
      colKey: 'NAME',
    });

    // ✅ 7. 후처리 (rowClickData 초기화)
    rowClickData.current = null;
  };

  // 탭 변경 핸들러
  const HandleChange = (event, newValue) => {
    // 세 번째 탭(안전보건공단 건강디딤돌) 클릭 시 외부 링크로 이동
    if (newValue === 2) {
      window.open(
        'https://portal.kosha.or.kr/business-apply-search/biz-support',
        '_blank'
      );
      return;
    }
    if (newValue === 0) setSearchClick1(true);
    else if (newValue === 1) setSearchClick2(true);
    setValue(newValue);
  };
  //#endregion

  return (
    <div className="wrap">
      <HEA_BASIC
        navigate={navigate}
        userInfo={userInfo}
        value={value}
        HandleChange={HandleChange}
        gridRef1={gridRef1}
        gridRef1_2={gridRef1_2}
        gridRef2={gridRef2}
        gridRef3={gridRef3}
        // rowData1, setRowData1 등은 HEA_BASIC_01F에서 관리됨
        modalRowData1={modalRowData1}
        setModalRowData1={setModalRowData1}
        selectedModalRowData1={selectedModalRowData1}
        setSelectedModalRowData1={setSelectedModalRowData1}
        changedModalRowData1={changedModalRowData1}
        setChangedModalRowData1={setChangedModalRowData1}
        modalToggle1={modalToggle1}
        setModalToggle1={setModalToggle1}
        rowClickData={rowClickData}
        excelData={excelData}
        setExcelData={setExcelData}
        readyToExport={readyToExport}
        setReadyToExport={setReadyToExport}
        fileInputRef={fileInputRef}
        // 함수
        handleCoChange={handleCoChange}
        handleCustChange={handleCustChange}
        validateSelection={validateSelection}
        PopupClickEvent1={PopupClickEvent1}
        SaveLogic2={SaveLogic2}
        handleRowSelection1={handleRowSelection1}
        printItem1={printItem1}
        printItem2={printItem2}
        ExcelDownload={ExcelDownload}
        NewYnErrorMsg={NewYnErrorMsg}
        HandleManageSelection={HandleManageSelection}
        // 탭별 클릭 핸들러
        searchClick1={searchClick1}
        setSearchClick1={setSearchClick1}
        saveClick1={saveClick1}
        setSaveClick1={setSaveClick1}
        deleteClick1={deleteClick1}
        setDeleteClick1={setDeleteClick1}
        printClick1={printClick1}
        setPrintClick1={setPrintClick1}
        printClick1Guideline={printClick1Guideline}
        setPrintClick1Guideline={setPrintClick1Guideline}
        searchClick2={searchClick2}
        setSearchClick2={setSearchClick2}
        saveClick2={saveClick2}
        setSaveClick2={setSaveClick2}
        deleteClick2={deleteClick2}
        setDeleteClick2={setDeleteClick2}
        printClick2={printClick2}
        setPrintClick2={setPrintClick2}
        printClick2Guideline={printClick2Guideline}
        setPrintClick2Guideline={setPrintClick2Guideline}
      />
      <Loading open={loading} />
    </div>
  );
}

export default HEA_BASICF;
